import { LocalizedPageTitle, PortfolioLayout, PortfolioLayoutHeader } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { WithGuideLink } from '@mews-commander/types';

export const Layout: React.FC<React.PropsWithChildren<Partial<WithGuideLink>>> = ({ guideLink, children }) => (
    <PortfolioLayout>
        <PortfolioLayoutHeader title={<LocalizedPageTitle textKey={TextKey.UserGroups} />} guideLink={guideLink} />
        {children}
    </PortfolioLayout>
);
